const firstTimeModalNewVerificationCode = {
  'first-time-modal-new-verificaion-code-message': 'Te hemos enviado un nuevo código de verificación. Por favor, abre tu correo electrónico y completa la verificación. Gracias por elegirnos.'
};

export default firstTimeModalNewVerificationCode;
